<template>
  <div class="app-container">
    <!--  :before-save="onBeforeSave" -->
    <common-dialog ref="dialog" width="350px" show-save-button title="手动点名" :subTitle="towerTitle"
      :subhead="dormTitle" id-key="SectionId" @opened="onOpened" :data="data" form-label-width="90px"
      :save-func="api.save" :get-data-func="() => { }" saveButtonText="提交" @closed="reset"
      @close-saved="$emit('close-saved')">
      <template slot="form">
        <div class="student-list">
          <div :class="{ 'student-item': true, 'be-late': item.status == 1, 'absent': item.status == 2 }"
            v-for="(item, index) of data.studentList" :key="index" @click="confirm(item,index)">
            <span>{{ item.studentsName }}</span>
            <span v-if="item.status == 1">迟到</span>
            <span v-if="item.status == 2">缺勤</span>
          </div>

        </div>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/attendance/night/commonDialog.vue";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      dormTitle: '',
      towerTitle: "",
      data: {
      },
      api: require("@/api/ed/section").default,
    };
  },
  methods: {
    confirm(data,index) {
      let title;
      if (data.status == 0) return;
      if (data.status == 1) { title = '确认迟到吗' };
      if (data.status == 2) { title = '确认缺勤吗' };

      this.$confirm(title,{
        confirmButtonText: "是",
        cancelButtonText: "否",
        
         center: true
      })
        .then(_ => {
          if(data.status == 1)  this.data.studentList[index].status = 1
          if(data.status == 2)  this.data.studentList[index].status = 2
        })
        .catch(_ => { 
          this.data.studentList[index].status = 0
        });
    },
    onOpened(data) {
      console.log(data);
      this.dormTitle = String(data.dormNo)
      this.towerTitle = String(data.towerNo)
      this.data = data;
    },
    reset() { },
  },
};
</script>
<style lang="scss" scoped>
// 迟到
.be-late {
  color: orange;
  cursor: pointer;
}

//缺勤
.absent {
  color: red;
  cursor: pointer;
}

.student-list {
  .student-item {
    padding: 6px 5px;
    display: flex;
    justify-content: space-between;
  }
}
</style>